let currentWebModalZIndex = 100

export const getNextWebModalZIndex = () => {
  currentWebModalZIndex += 1
  return currentWebModalZIndex
}

export const createWebModalLayerStyle = (style = {}) => {
  const nextZIndex = getNextWebModalZIndex()

  if (style && typeof style === 'object' && !Array.isArray(style)) {
    return {
      ...style,
      zIndex: nextZIndex,
    }
  }

  return {
    zIndex: nextZIndex,
  }
}
